/**
 * 车辆浏览汇总信息统计，按每辆车的纬度统计
 */
import React from 'react';

import { Row, Col, DatePicker, Input, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

//商户选择
import MemberSelect from '../../crm/member/MemberSelect';

import http from '../../../axios/http';
import Loading from '../../ui/Loading';

class VehicleBrowseSum extends React.Component {

    columns = [{
        title: '商户名称',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '浏览次数',
        dataIndex: 'visitTimes',
        width: '10%',
    }, {
        title: '浏览时间/s',
        dataIndex: 'stayTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, key) =>{
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        this.setState({ loadingVisible: true });
        let queryData = this.state.queryData;
        queryData.pageNo = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/mallLog/browsing/vehicle/downloadSum',
            data: queryData,
            fileName: "车辆浏览汇总记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                {/* <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '200px'}}
                                /> */}
                                <MemberSelect placeholder="商户" mall={1} allowClear={true} onChange={this.memberSelect} style={{ width: '250px' }} />
                                <Input.Search
                                    placeholder="车辆名称"
                                    onSearch={this.inputSearch.bind(this, "vehicleName")}
                                    enterButton
                                    style={{  margin: '0 10px', width: '200px'}}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallLog/browsing/vehicle/summary"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default VehicleBrowseSum;